import React, { useEffect, useState } from 'react'
import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { useWeb3React } from '@web3-react/core';
import { ABI, API_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid, Matic_Chain_symbol } from '../../Config';
import Loading from "../../Components/loader/loader";
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import sport11 from '../../images/sport11.png'
 

const Membershipplan = () => {
    const { library, chainId, account } = useWeb3React();
    const [Data, Setdata] = useState([]);
    const [isloading, setisloding] = useState("");
    const history = useHistory();
    const [Alreadybuy, Setalreadybuy] = useState(0);
    const [planid, setplanid] = useState('');
    const [Buydate, setbuydate] = useState('');
    const [Userdata, Setuserplandata] = useState("");
    const [Disableplan, setdisableplanplan] = useState([]);

    const Fetchmembercard = async () => {

        if (library) {
            let contract_address;
            if (chainId == Bsc_Chainid) {
                contract_address = bsccontractaddress;
            } else if (chainId == Matic_Chainid) {
                contract_address = maticcontractaddress;
            } else if (chainId == ETH_Chainid) {
                contract_address = ethcontractaddress;
            }

            const Web3 = require('web3');
            const web3 = new Web3(library.provider);
            const contract = await new web3.eth.Contract(ABI, contract_address);
            let plans = await contract.methods.getcardinfo().call();
            let i = 0;
            let arr = [];
            while (i < Number(plans.length)) {
                let data = await getusersbyplan(i);
                arr.push(data.length);
                i++;
            }
            Setdata(plans);
            Setuserplandata(arr);
        } 
    }

    const getusersbyplan = async (planid) => {
        if (library) {
            let contract_address;
            if (chainId == Bsc_Chainid) {
                contract_address = bsccontractaddress;
            } else if (chainId == Matic_Chainid) {
                contract_address = maticcontractaddress;
            } else if (chainId == ETH_Chainid) {
                contract_address = ethcontractaddress;
            }
            const Web3 = require('web3');
            const web3 = new Web3(library.provider);
            let contract = new web3.eth.Contract(ABI, contract_address);
            return await contract.methods.fetchUsers(planid).call();

        } else {
            swal({
                icon: "error",
                text: 'Please connect your wallet',
                title: "Warning",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
            })
        }
    }

    const Buy = async (cardid, amount, day, user) => {
        if (library) {
            setisloding(true);
            let contract_address;
            if (chainId == Bsc_Chainid) {
                contract_address = bsccontractaddress;
            } else if (chainId == Matic_Chainid) {
                contract_address = maticcontractaddress;
            }
            let value = Number(amount / 10 ** 18);
            const Web3 = require("web3");
            const web3 = new Web3(library.provider);
            const contract = await new web3.eth.Contract(ABI, contract_address);
            contract.methods.buymembership(cardid).send({ from: account, value: amount }).then((result) => {
                update(value, day, user, cardid)
                setisloding(false);
                swal({
                    icon: "success",
                    text: 'You Bought the Plan',
                    title: "Success",
                    allowOutsideClick: false,
                    confirmButtonText: 'ok',
                    confirmButtonColor: '#2dbe60',
                }).then(() => {
                    history.push('./Myitem')
                })
            }).catch(() => {
                setisloding(false);
            })
        }
    }

    useEffect(() => {
        Fetchmembercard();

    }, [library])

    const update = async (value, day, user, cardid) => {
        let currency;
        if (chainId == Bsc_Chainid) {
            currency = "BNB";
        } else if (chainId == Matic_Chainid) {
            currency = "MATIC";
        }
        var data = new FormData();
        data.append("type", 'Insertdata');
        data.append("Buyeraddress", account);
        data.append("Amount", value);
        data.append("Days", day)
        data.append("Totalusers", user)
        data.append("currency", currency)
        data.append("Planid", cardid)

        return await axios.post(`${API_URL}/savecardinfo.php`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    const fetchmemberinfo = async () => {
        let currency;
        if (chainId == Bsc_Chainid) {
            currency = 'BNB';
        } else if (chainId == Matic_Chainid) {
            currency = 'MATIC';
        }

        var data = new FormData();
        data.append("type", "Fetchdata");
        data.append("address", account);
        data.append("currency", currency)


        await axios.post(`${API_URL}/savecardinfo.php`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then((result) => {
            
            if (result.data.length > 0) {
                setbuydate(result.data[0].Date)
                console.log(result.data[0].Date);
                let startdate = result.data[0].Date;
                let daa = new Date(startdate);
                console.log(daa,'datae');
          
            }
        })
    }

    const fetchhaveaplan = () => {
        if (library) {
            let contract_address;
            if (chainId == Bsc_Chainid) {
                contract_address = bsccontractaddress;
            } else if (chainId == Matic_Chainid) {
                contract_address = maticcontractaddress;
            } else if (chainId == ETH_Chainid) {
                contract_address = ethcontractaddress;
            }

            if (contract_address) {
                const Web3 = require("web3");
                const web3 = new Web3(library.provider);
                const contract = new web3.eth.Contract(ABI, contract_address);
                contract.methods.Userplan(account).call().then((planid) => {
                    if (planid > 0) {
                        Setalreadybuy(1);
                        setplanid(Number(planid) - 1);
                    }
                }).catch()
            }
        }
    }

    const disableplan = async () => {
        let currency;
        if (chainId == Bsc_Chainid) {
            currency = 'BNB';
        } else if (chainId == Matic_Chainid) {
            currency = 'MATIC';
        } else if (chainId == ETH_Chainid) {
            currency = 'ETH';
        }


        await axios.get(`${API_URL}/Deletecard.php?currency=${currency}`, {
            headers: {
                "Content-Type": "application/json",
            },
        }).then((result) => {
            if (result.data.length > 0) {
                setdisableplanplan(result.data.map(item => item.PlanId))
            }
        })
    }

    useEffect(() => {
        fetchmemberinfo();
        disableplan();
    }, [account, chainId ])

    useEffect(() => {
        fetchhaveaplan();
    }, [account, chainId])

    return (
        <div>
            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        Membership Plan
                    </Typography>
                </Box>
            </Box>
            <Box className="membership">
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                        {Data ? Data.map((token, idx) => !Disableplan.includes(idx.toString()) && (

                            <Grid key={idx} item lg={4} sm={6} md={4} xs={12} marginBottom='20px'>
                                <Box className='basicplan' textAlign='center' marginY={'3rem'}>
                                    <Typography variant='h1' fontSize='25px' fontWeight='500' textAlign='center'>Plan {idx + 1} </Typography>
                                    <img className='basicplan_pht' src={sport11} alt='' />
                                    <ul>
                                        <li>Amount <span> {Number(token.amount) / 10 ** 18} {chainId && chainId == Bsc_Chainid ? "BNB" : "MATIC"}</span></li>
                                        <li>Number of Days <span>{token.day} </span></li>
                                        <li>Number of Users can buy <span>{token.user}</span></li>
                                    </ul>
                                   
                                
                                    {Number(Alreadybuy) == Number(0) ?
                                        <Box paddingBottom='30px'>
                                            <Button variant='contained' className='grbtn' onClick={() => Buy(idx, token.amount, token.day, token.user)}>Buy</Button>
                                        </Box>
                                        : Number(Alreadybuy) == Number(1) && idx == planid && new Date(Buydate).setDate(new Date(Buydate).getDate() + Number(token.day)) > new Date().getTime() ?
                                            <Box paddingBottom='30px'>
                                                <Button variant='contained' className='grbtn'> Bought </Button>
                                            </Box>
                                            : Number(Alreadybuy) == Number(1) && idx == planid && new Date(Buydate).setDate(new Date(Buydate).getDate() + Number(token.day)) < new Date().getTime() ?
                                                <Box paddingBottom='30px'>
                                                  <Button variant='contained' className='grbtn' onClick={() => Buy(idx, token.amount, token.day, token.user)}>Buy</Button>
                                                </Box>
                                            :Number(Alreadybuy) == Number(1) && Number(Userdata[idx])>= Number(token.user)?
                                            <Box paddingBottom='30px'>
                                               <Button variant="contained" disabled className='grbtn'>Buy </Button>
                                                <Typography  color={'red'} >User limit reached</Typography>
                                            </Box> 
                                            : Number(Alreadybuy) == Number(1)  ?
                                            <Box paddingBottom='30px'>
                                               <Button variant='contained' className='grbtn' onClick={() => Buy(idx, token.amount, token.day, token.user)}>Buy</Button>
                                            </Box> 
                                            :
                                            <Box paddingBottom='30px'>
                                                <Button variant="contained" disabled className='grbtn'>Buy</Button>
                                            </Box>
                                    }
                                </Box>
                            </Grid>
                        )) : (

                            <Grid item lg={4} sm={6} md={4} xs={12} marginBottom='20px'>
                                <Box className='basicplan' textAlign='center' marginY={'3rem'}>
                                    <Typography variant='h1' fontSize='25px' fontWeight='500' textAlign='center'>Plan</Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Container>
            </Box>
            {isloading && <Loading props={'Transaction in process, Please wait do not refresh the page...'} />}
        </div>
    )
}

export default Membershipplan; 